// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oZ8Z","toggle":"styles_toggle__1UnCe","preview":"styles_preview__2k0xv"};